/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditProfileRequest extends models.RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditProfileRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditProfileRequest>): RequestAuditProfileRequest {
        let obj = Object.assign(new RequestAuditProfileRequest(), model);
        RequestAuditProfileRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditProfileRequest>): RequestAuditProfileRequest {
        if (!model) return null;
        return RequestAuditProfileRequest.newInstance(<RequestAuditProfileRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditProfileRequest) {
        if (!obj) return;

        models.RequestAuditProfileRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditProfileRequest): boolean {
        if (models.RequestAuditBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditProfileRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.activations === undefined) {
            this.activations = 0;
        }
        if (this.execution_time_threshold === undefined) {
            this.execution_time_threshold = 0;
        }
    }

    /**
     * Target endpoint
     */
    endpoint: string;

    /**
     * Target resource path
     */
    path: string;

    /**
     * Number of activations.
     */
    activations: number;

    /**
     * Only log profiles that take longer than this time.
     */
    execution_time_threshold: number;

}
